import { useSelector } from 'react-redux';
import { getAuthTeamMember } from 'store/authentication/selectors';

export const useCurrentUserId = (): string | undefined =>
  useSelector(getAuthTeamMember)?.user;
